import script from "./GamesCalendarSection.vue?vue&type=script&setup=true&lang=js"
export * from "./GamesCalendarSection.vue?vue&type=script&setup=true&lang=js"

import "./GamesCalendarSection.vue?vue&type=style&index=0&id=09ef8220&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09ef8220"]])

export default __exports__